/* eslint-disable camelcase */
  <template>
  <v-container class="py-4">
    <v-card class="mx-auto" max-width="1400" elevation="4">
      <!-- Título com fundo azul e ícone -->
       <v-card-title class="white--text" style="background-color:#006699;">
  <v-icon left class="mr-2">mdi-account-group</v-icon>
  <span class="text-h6 font-weight-medium">Lista de Clientes</span>
  
  <v-spacer></v-spacer>
  
  <v-text-field
    v-model="pesquisa"
    placeholder="Pesquisar..."
    dense
    hide-details
    solo-inverted
    color="white"
    prepend-inner-icon="mdi-magnify"
    style="max-width: 250px; background-color: white; border-radius: 4px;"
  ></v-text-field>
</v-card-title>


      <!-- Overlay de carregamento -->
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>

      <!-- Tabela de clientes -->
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="clientes"
          :search="pesquisa"
          class="elevation-1"
          item-value="id"
          dense
        >
          <!-- Coluna de ordem -->
          <template v-slot:item.ord="{ item }">
            <span>{{ clientes.indexOf(item) + 1 }}</span>
          </template>

          <!-- Ações -->
          <template v-slot:item.action="{ item }">
            <v-menu
              offset-x
              offset-y
              transition="scale-transition"
              close-on-content-click
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  elevation="1"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item @click="abrirEdicao(item)">
                  <v-icon left color="blue">mdi-pencil</v-icon>
                  <span class="ml-2">Editar Dados</span>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card-text>

      <!-- Componente de edição -->
      <editar-cliente
        v-model="dialogEditar"
        :cliente-original="clienteSelecionado"
        @cliente-editado="atualizarCliente"
      />
    </v-card>
  </v-container>
</template>

My CRUD
<script>
import axios from '../../../plugins/axios'
import utilitarios from '../../../plugins/utilitarios'
import editarCliente from './componentes/editarCliente.vue'
export default {
  components:{editarCliente},    
  data: () => ({
    clientes: [],
    progresso: false,
    offsetX: false,
    offsetY: true,
    overlay: false,
    pesquisa:'',
    tab: null,
    dialogEditar: false,
    clienteSelecionado: null,
    utilitarios: utilitarios,
    dialog_detalhes: false,
    dados_contaCorrente: [],
    dados_contaCorrente_saidas: [],
    search: '',
    headers: [
    { text: '#', value: 'ord' },
      {
        text: 'Nome do cliente',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      { text: 'Nif', value: 'nif' },
       { text: 'Telefone', value: 'telefone' },
      { text: 'Registrador por', value: 'autor' },
       { text: 'Ações', value: 'action' }
    ],
    tabsItems:
    [
      { id: 1, tab: 'Geral' },
      { id: 2, tab: 'Preços' },
      { id: 3, tab: 'Estoque' },
      { id: 3, tab: 'Conta Corrente do Produto' }
    ],
    editedItem:
     {
       armazem: '',
       codigoBarra: '',
       descricaoPreco: '',
       descricaoReduzida: '',
       entrada_stk: 0,
       especificacaoProduto: '',
       familia: '',
       isencao: '',
       iva: 0,
       margem: 0,
       mercadoria: '',
       pkArmazem: 0,
       pkFamilia: 0,
       pkProduto: 0,
       precoComIva: 0,
       precoSemIva: 0,
       produto: '',
       stock_max: null,
       stock_min: null,
       tipoProduto: 0,
       unidade: 0,
       controleStock: 0,
       precoVendaDefinido: 0,
       calculoPrecoVenda: 0
     },
     cliente:{
       nome:'',
       nif:''
     }
  }),
  computed: {
    totalExistencias () {
      let total = 0
      this.produtos.forEach(element => {
        total += parseInt(element.entrada_stk)
      })
      return total
    }
  },

  created () {
    this.Init()
  },

  methods: {
    async  Init () {
      try {
        //   let  payload =""
        this.progresso = true
        this.clientes = await axios
          .get('/listarClientes')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
     
   abrirEdicao(cliente) {
    this.clienteSelecionado = cliente;

      
    this.dialogEditar = true;
  },
  atualizarCliente(clienteEditado) {
     this.Init()
     this.dialogEditar = false;
  }

  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}
</style>
